import { APICore } from "./apiCore";

const api = new APICore();

const getPulseSentimento = (queryString?: string) => {
    return api.get(`/pulse-sentimento${queryString ? queryString : ""}`);
};

const criaPulseSentimento = (params: any) => {
    return api.create(`/pulse-sentimento`, params);
};

const verificaPulseSentimentoSemana = (colaborador_id: number) => {
    return api.get(`/pulse-sentimento/verifica-semana/${colaborador_id}`);
};

export {
    getPulseSentimento,
    criaPulseSentimento,
    verificaPulseSentimentoSemana
};